import api from './api';
import type { AlmacenDto } from '@/types/inventario';

export const almacenesApi = {
  findAll: (soloActivos = true) =>
    api
      .get<AlmacenDto[]>('/almacenes', { params: { soloActivos } })
      .then((r) => r.data),
};
